import { Conversation as ConversationBase } from '@domain-group/suit-theme'

import useSubjectConversation from '@hooks/useSubjectConversation'

import type { EntityOptions } from '@redux/modules/types'

import BlankState from '@components/BlankState'

import Comment from './Comment'

import ConversationImageUrl from './assets/conversation.svg'

interface ConversationProps {
  boxProps?: object,
  requestOptions?: EntityOptions,
  showAddCommentBox?: boolean,
  subjectId: number,
  subjectType: string,
  title: string,
}

const Conversation = (props: ConversationProps) => {
  const {
    boxProps, requestOptions, showAddCommentBox = true, subjectId, subjectType, title,
  } = props

  const subjectConversationPayload = useSubjectConversation({
    conversation: {
      subject_id: subjectId,
      subject_type: subjectType,
      title,
    },
    performHttpRequests: !!subjectId,
    requestOptions,
  })

  const {
    callbacks: { createCommentWithConversation },
    commentCount,
    comments,
    creating,
    loading,
  } = subjectConversationPayload

  const hasComments = !loading && commentCount > 0

  return (
    <ConversationBase
      boxProps={boxProps}
      callbacks={{ createCommentWithConversation }}
      commentsBoxProps={{
        alignItems: !hasComments ? 'center' : undefined,
        height: !hasComments ? 270 : undefined,
        justifyContent: !hasComments ? 'center' : undefined,
      }}
      commentCount={commentCount}
      creating={creating}
      loading={loading}
      requestOptions={requestOptions}
      showAddCommentBox={showAddCommentBox}
    >
      {!hasComments && (
        <BlankState
          imageUrl={ConversationImageUrl}
          title="No Comments"
          subtitle="Keep a detailed history of work, decisions and requests in the conversation."
        />
      )}

      {comments.map(comment => (
        <Comment comment={comment} hideLastChildBottomBorder={!showAddCommentBox} key={comment.id} />
      ))}
    </ConversationBase>
  )
}

export default Conversation
